export enum UserType {
    ADMIN = 1,
    DEALER = 2,
    USER = 3,
    REVIEWER = 4,
}
